module.exports = __webpack_public_path__ + "static/media/bg2-5.4113ec19.png";